import React from 'react';
import { convertStyle, YKScroll } from '../../../../utils/index';
import MenuItem from './menu-item/menu-item';
import './custom-menu.less';

const menuTypes = {
  imgAndTit: {
    containerClassName: 'thumb-scroll-container',
    itemType: 'imgAndTit',
    direction: 'v',
  },
  imgAndTit2: {
    containerClassName: 'thumb-scene-container',
    itemType: 'imgAndTit2',
    direction: 'h',
  },
  icnAndTit: {
    containerClassName: 'scroll-bar-container',
    itemType: 'icnAndTit',
    direction: 'h',
  },
  title: {
    containerClassName: 'scroll-bar-container-small',
    itemType: 'title',
    direction: 'h',
  },
  title2: {
    // 户型楼层切换
    containerClassName: 'scroll-bar-container-small-2',
    itemType: 'title2',
    direction: 'v',
  },
  title3: {
    // 户型2d/3d模式切换
    containerClassName: 'scroll-bar-container-small-3',
    itemType: 'title3',
    direction: 'h',
  },
  title4: {
    containerClassName: 'scroll-bar-container-small',
    itemType: 'title4',
    direction: 'h',
  },
  housetypeItem: {
    containerClassName: 'house-type-container',
    itemType: 'housetypeItem',
    direction: 'h',
  },
  default: {
    containerClassName: 'xsdj-custom-menu-default',
    itemType: 'img',
    direction: 'h',
  },
};
let count = 1;

export default class CustomMenu extends React.Component<any, any> {
  static defaultProps = {
    levelInfo: {},
    activeIndex: 0,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClickItem: () => {},
    referWidth: null,
    referHeight: null,
    containerWidth: null,
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.scroller = React.createRef();
  }

  componentDidMount() {
    this.scroller.current = new YKScroll({
      element: this.scroller.currentr,
    });
  }

  componentDidUpdate(prevProps) {
    const { type, activeIndex } = this.props;
    if (activeIndex !== prevProps.activeIndex) {
      this.scroller.current.scrollTo(
        `#${this.state.id} .active`,
        10,
        menuTypes[type || 'default'].direction,
      );
    }
  }

  scroller: any;

  getDefaultState = () => {
    const { levelInfo } = this.props;
    return {
      direction: 'h',
      id: `custom-menu-${count++}`,
      type: (levelInfo && levelInfo.type) || 'default',
    };
  };

  handleConvertStyle = (style) => {
    const { referWidth, referHeight, containerWidth } = this.props;
    return convertStyle(style, {
      referWidth,
      referHeight,
      width: containerWidth || innerWidth,
    });
  };

  render() {
    const { levelInfo, className, referWidth, activeIndex, onClickItem } = this.props;
    // const { children } = this.props;
    const { type } = this.state;
    if (!levelInfo || !levelInfo.list) return null;
    if (type === 'default' && !referWidth) return null;

    const { containerClassName, itemType } = menuTypes[type];
    let { direction } = menuTypes[type];
    direction = levelInfo.direction || direction;
    const directionClassName = direction === 'v' ? 'xsdj-custom-menu-v' : 'xsdj-custom-menu-h';
    return (
      <div
        style={{ ...this.handleConvertStyle(levelInfo.containerStyle) }}
        className={`xsdj-custom-menu ${containerClassName} ${directionClassName} ${className}`}
        ref={this.scroller}
        id={this.state.id}
      >
        {levelInfo.list.map((item, index) => (
          <React.Fragment key={index}>
            <MenuItem
              type={itemType || 'img'}
              direction={direction}
              title={itemType.includes('img') ? item.title : item.name}
              imageId={item.image}
              tabIconNormal={item.tabIconNormal}
              tabIconActive={item.tabIconActive}
              housetypeItemInfo={item}
              style={{
                ...this.handleConvertStyle(levelInfo.itemStyle),
                display: item.hide && 'none',
              }}
              activeStyle={{ ...this.handleConvertStyle(levelInfo.itemActiveStyle) }}
              active={activeIndex === index}
              activeBar={levelInfo.activeBar}
              thumb={item.thumb}
              onClickItem={(e) => {
                onClickItem(item, index, e);
              }}
            />
            {/* {activeIndex === index && children} */}
          </React.Fragment>
        ))}
      </div>
    );
  }
}
